/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

 const fallbackImgURL = 'https://images.contentstack.io/v3/assets/bltdd99f24e8a94d536/bltd7fb53e04e8ff8f8/61421371845f6b45b4da61ab/image_not_available_987x1080.png';

 export default fallbackImgURL;